import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PostEntityFormFields {

    public name: FormField
    public description: FormField
    public editPermissions: FormField
    public project: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          true,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          true,
          true,
          ""
        )
        this.editPermissions = new FormField(
          'editPermissions',
          'Edit permissions',
          null,
          FormFieldType.boolean,
          true,
        )
        this.project = new FormField(
          'project',
          'Project',
          'project',
          FormFieldType.pushedSelectionList,
          true,
        )

    }
}

const fields = new PostEntityFormFields()

export const postEntityFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  description: fields.description,
  editPermissions: fields.editPermissions,
  project: fields.project,
};